<div class="ui-fluid ng-main aurora-theme" >
  <p-toast position="bottom-right"></p-toast>
  <div [class.hidden]="!showLoader" class="np-loader">
    <p-progressSpinner strokeWidth="5"></p-progressSpinner>
  </div>
  
  <router-outlet></router-outlet>
  
</div>